import { Injectable } from '@angular/core';
import { Observable, forkJoin, throwError } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from 'src/app/auth-o3/shared/services/auth.service';
import { CurrentUserService } from 'src/app/auth-o3/shared/services/current-user.service';
import { UsersService } from 'src/app/auth-o3/shared/services/users.service';
import { TABLES } from '../models/consts/tables';

const TABLES_TO_SHOW = [
  'tradingCalendars',
  'settlementCalendars',
  'referenceEntity',
  'referenceObligation',
  'legalProgrammes',
  'issuersEntity',
  'listingVenues',
  'agents',
  'physicalSettlementMatrix',
  'underlyingAssets',
  'exchanges',
  'dataIngestionConfig',
  'dataExportFormats',
  'desks',
  'contacts',
  'hurdlesAndSpreads',
];

@Injectable({
  providedIn: 'root',
})
export class StaticDataTableService {
  constructor(
    private authService: AuthService,
    private userService: UsersService,
    private currentUserService: CurrentUserService
  ) {}

  getTables(): Observable<any> {
    return this.currentUserService.currentUser.pipe(
      take(1),
      switchMap(({ id }) => {
        return forkJoin([
          this.authService.getUserTenant().pipe(take(1)),
          this.userService.user(id).pipe(take(1)),
        ]);
      }),
      map(([tenantIds, { role }]) => this.getFilteredTables(tenantIds, role)),
      catchError((error) => throwError(error))
    );
  }

  private getFilteredTables(tenantIds: any, roles: any): any {
    if (!tenantIds) {
      throw "You don't have any tenant assigned to you. Please contact your administrator.";
    }
    const tablesFilteredByRole = TABLES.filter(
      ({ permittedForRoles }) =>
        !permittedForRoles ||
        permittedForRoles.some((role) => roles.includes(role))
    );
    const tablesFilteredByTenants = tablesFilteredByRole.filter(({ key }) =>
      TABLES_TO_SHOW.includes(key)
    );
    return tablesFilteredByTenants;
  }
}
